import { render } from "./RefreshColumns.vue?vue&type=template&id=16e1f54f&scoped=true"
import script from "./RefreshColumns.vue?vue&type=script&lang=js"
export * from "./RefreshColumns.vue?vue&type=script&lang=js"

import "./RefreshColumns.vue?vue&type=style&index=0&id=16e1f54f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e1f54f"]])

export default __exports__